export default __webpack_public_path__ + "static/media/kuwait.88437422.png";